import { useCallback, useState } from 'react';
import { useRouter } from './useRouter';
import { useSubscription } from './useSubscription';
/**
 * Возвращает список location.search и позволяет задать новые
 */
export function useSearch() {
    const router = useRouter();
    const [searchStr, setSearchStr] = useState(router.getSearch());
    const onChange = useCallback(() => {
        if (typeof location !== 'undefined' && location.search !== searchStr) {
            setSearchStr(location.search);
        }
    }, [searchStr, setSearchStr]);
    useSubscription(onChange);
    const setSearch = useCallback(params => {
        const search = new URLSearchParams(params);
        router.navigate(`${router.getPath()}?${search}`, true);
    }, [router]);
    return [router.getSearchParsed(), setSearch];
}
